import React, { ReactNode } from "react";
import ViewController from "../commons/base/view_controller";
import Scaffold from "../commons/scaffold/scaffold";
import ShopeeOrderDashboardState from "./models/shopee_order_dashboard_state";
import ShopeeOrderDashboardViewModel from "./view_models/shopee_order_dashboard_view_model";

export default class ShopeeOrderDashboardScreen extends ViewController<
    {}, 
    ShopeeOrderDashboardState,
    ShopeeOrderDashboardViewModel
> {
    interval?: NodeJS.Timer;

    constructor(props: {}) {
        super(props, new ShopeeOrderDashboardViewModel());
    }

    componentDidMount(): void {
        if (!this.interval) {
            this.interval = setInterval(() => this.viewModel.loadData(), 10000);
        }
    }

    componentWillUnmount(): void {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render(): ReactNode {
        return (
            <Scaffold isShowLoading={this.vmState.isLoading} >
                {this.vmState.errorMessage.length > 0 && (
                    <h1 className="text-red-600 mt-12">
                        {this.vmState.errorMessage}
                    </h1>
                )}
                <div className="justify-center mt-16">
                    <h1 className="text-[32px] text-purple-800 font-bold">Order Shopee Siap Diambil Driver</h1>
                </div>
                <table className="p-8 mt-2 w-full">
                    <tr className="bg-gray-800 border-1 text-white">
                        <th>Selesai Masak</th>
                        <th>Outlet</th>
                        <th>Order Id</th>
                        <th>Kode Platform</th>
                        <th>Nama Cu</th>
                        <th>Menu</th>
                        <th>Sudah Tick di App?</th>
                    </tr>
                    {
                    this.vmState.orderArr.length > 0
                        ?this.vmState.orderArr.map((order) => {
                            return <TableRow 
                                finishCookingAt={new Date(order.finishedCookingAt)}
                                outlet={order.outletName}
                                orderId={order.orderId}
                                platformId={order.platformId}
                                customerName={order.customerName}
                                menuAndQuantity={order.menuAndQuantity}
                                action={() => this.viewModel.setCollectedByDriver(order.orderId)}
                            />
                        })
                        :<tr><td colSpan={7}><h1>Tidak ada order baru</h1></td></tr>
                    }
                </table>
            </Scaffold>
        )
    }
}

interface TableRowProps {
    finishCookingAt: Date;
    outlet: string;
    orderId: string;
    platformId: string;
    customerName: string;
    menuAndQuantity: string[];
    action: () => void
}

class TableRow extends React.Component<TableRowProps> {
    render(): ReactNode {
        const rowStyle = "border-4 border-grey-800 border";

        const finishCookingAt = 
        `${this.props.finishCookingAt.getHours().toString().padStart(2, "0")}:${this.props.finishCookingAt.getMinutes().toString().padStart(2, "0")}`;

        return (
            <tr key={this.props.orderId} className="px-6 h-[60px]">
                <td className={rowStyle}>{finishCookingAt}</td>
                <td className={rowStyle}>{this.props.outlet}</td>
                <td className={rowStyle}>{this.props.orderId}</td>
                <td className={rowStyle}>{this.props.platformId}</td>
                <td className={rowStyle}>{this.props.customerName}</td>
                <td className={rowStyle}>{
                        this.props.menuAndQuantity.map((el) => {
                            return <span className="mx-3 bg-yellow-100 border border-black">{el}</span>
                        })
                    }
                </td>
                <td className={rowStyle}>
                    <button className="bg-green-600 text-white h-[34px] w-[60px] rounded" onClick={this.props.action}>
                        Done
                    </button>
                </td>
            </tr>
        );
    }
}